import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../services/auth';

// Guard del panel de closers: mismo patrón que AdminRoute.
const CloserRoute = ({ children }) => {
  const [isAuthorized, setIsAuthorized] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const hasToken = authService.isAuthenticated();

        if (!hasToken) {
          setIsAuthorized(false);
          setIsLoading(false);
          return;
        }

        const user = await authService.getCurrentUserFromBackend();

        if (user && user.role === 'closer') {
          setIsAuthorized(true);
        } else {
          setIsAuthorized(false);
        }
      } catch (error) {
        console.error('Error verificando autorización:', error);
        setIsAuthorized(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-white text-lg">Cargando...</div>
      </div>
    );
  }

  if (!isAuthorized) {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        if (user.role === 'admin') {
          return <Navigate to="/admin" replace />;
        }
        if (user.role === 'cliente' || user.role === 'tienda') {
          return <Navigate to="/home" replace />;
        }
      } catch (error) {
        // Error parsing, redirigir al login
      }
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default CloserRoute;
